export const perf = {
  now: (): number => {
    if (typeof performance !== 'undefined' && performance.now) {
      return performance.now();
    } else {
      return new Date().getTime();
    }
  },

  mark: (name: string): void => {
    if (typeof performance !== 'undefined' && performance.mark) {
      performance.mark(name);
    }
  },
  measure: (name: string, start: string, end: string): void => {
    if (typeof performance !== 'undefined' && performance.measure) {
      performance.measure(name, start, end);
    }
  },
  getEntriesByName(url: string): PerformanceEntryList | undefined {
    if (typeof performance !== 'undefined' && performance.getEntriesByName) {
      return performance.getEntriesByName(url);
    }
    return undefined;
  },
  getEntriesByType(type: string): PerformanceEntryList | undefined {
    if (typeof performance !== 'undefined' && performance.getEntriesByType) {
      return performance.getEntriesByType(type);
    }
    return undefined;
  },
};
